
export const getSponsorApiGet = (data) => {
    return data.data
}



